import { keyBy } from 'lodash';
import { getApiFilterTransformer, to_filter } from 'components/pages/api-filter-transformer';
import { hasValidFilters } from 'utils/filters/nested-filter-utils';
import { getDynamicConditionFields } from '../utils';
export const getDynamicConditionsFromPayload = (templateContent, projectCustomFields)=>{
    const conditions = {};
    const fields = getDynamicConditionFields(projectCustomFields);
    const transformer = getApiFilterTransformer(keyBy(fields, 'fieldName'));
    templateContent.projectPhases.forEach((phase)=>{
        var _phase_sprints;
        if (phase.filters) {
            const transformedFilter = transformer.from(phase.filters);
            if (hasValidFilters(transformedFilter)) {
                conditions[phase.projectPhaseId] = transformedFilter;
            }
        }
        phase.tasks.forEach((task)=>{
            if (task.filters) {
                const transformedFilter = transformer.from(task.filters);
                if (hasValidFilters(transformedFilter)) {
                    conditions[task.taskId] = transformedFilter;
                }
            }
            task.subTasks.forEach((subTask)=>{
                if (subTask.filters) {
                    const transformedFilter = transformer.from(subTask.filters);
                    if (hasValidFilters(transformedFilter)) {
                        conditions[subTask.taskId] = transformedFilter;
                    }
                }
                subTask.subTasks.forEach((_subTask)=>{
                    if (_subTask.filters) {
                        const transformedFilter = transformer.from(_subTask.filters);
                        if (hasValidFilters(transformedFilter)) {
                            conditions[_subTask.taskId] = transformedFilter;
                        }
                    }
                });
            });
        });
        (_phase_sprints = phase.sprints) === null || _phase_sprints === void 0 ? void 0 : _phase_sprints.forEach((sprint)=>{
            if (sprint.filters) {
                const transformedFilter = transformer.from(sprint.filters);
                if (hasValidFilters(transformedFilter)) {
                    conditions[sprint.sprintId] = transformedFilter;
                }
            }
        });
    });
    templateContent.spaceList.forEach((space)=>{
        if (space.filters) {
            const transformedFilter = transformer.from(space.filters);
            if (hasValidFilters(transformedFilter)) {
                conditions[space.spaceId] = transformedFilter;
            }
        }
        space.spaceTabs.forEach((spaceTab)=>{
            if (spaceTab.filters) {
                const transformedFilter = transformer.from(spaceTab.filters);
                if (hasValidFilters(transformedFilter)) {
                    conditions[spaceTab.spaceTabId] = transformedFilter;
                }
            }
        });
    });
    return conditions;
};
export const setDynamicConditionInPayload = (projectTemplate)=>{
    const { projectPhases, tasks, sprints, spaceList, dynamicConditions } = projectTemplate;
    const _phases = Object.values(projectPhases).map((_phase)=>{
        const { projectPhaseId, filters, ...rest } = _phase;
        if (dynamicConditions && dynamicConditions[projectPhaseId]) {
            return {
                ..._phase,
                filters: to_filter(dynamicConditions[projectPhaseId])
            };
        }
        return {
            projectPhaseId,
            ...rest
        };
    });
    const _tasks = Object.values(tasks).map((_task)=>{
        const { taskId, filters, ...rest } = _task;
        if (dynamicConditions && dynamicConditions[taskId]) {
            return {
                ..._task,
                filters: to_filter(dynamicConditions[taskId])
            };
        }
        return {
            taskId,
            ...rest
        };
    });
    const _sprints = Object.values(sprints).map((_sprint)=>{
        const { sprintId, filters, ...rest } = _sprint;
        if (dynamicConditions && dynamicConditions[sprintId]) {
            return {
                ..._sprint,
                filters: to_filter(dynamicConditions[sprintId])
            };
        }
        return {
            sprintId,
            ...rest
        };
    });
    const _spaceLists = Object.values(spaceList).map((_spaceList)=>{
        const { spaceId, filters, ...rest } = _spaceList;
        const newSpaceList = {
            spaceId,
            ...rest
        };
        newSpaceList.spaceTabs = _spaceList.spaceTabs.map((_spaceTab)=>{
            const { spaceTabId, filters: spaceTabFilters, ...restdata } = _spaceTab;
            if (dynamicConditions && dynamicConditions[spaceTabId]) {
                return {
                    ..._spaceTab,
                    filters: to_filter(dynamicConditions[spaceTabId])
                };
            }
            return {
                spaceTabId,
                ...restdata
            };
        });
        if (dynamicConditions && dynamicConditions[spaceId]) {
            return {
                ...newSpaceList,
                filters: to_filter(dynamicConditions[spaceId])
            };
        }
        return newSpaceList;
    });
    return {
        ...projectTemplate,
        projectPhases: keyBy(_phases, 'projectPhaseId'),
        tasks: keyBy(_tasks, 'taskId'),
        sprints: keyBy(_sprints, 'sprintId'),
        spaceList: keyBy(_spaceLists, 'spaceId')
    };
};
